import { render, staticRenderFns } from "./MediaQueries.vue?vue&type=template&id=155d2db2"
import script from "./MediaQueries.vue?vue&type=script&lang=js"
export * from "./MediaQueries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports